import {
  getSupportedCurrencies
} from "./chunk-ZJYF4UXN.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/currency/list.ts
import { useQuery } from "@tanstack/react-query";
var useGetSupportedCurrencies = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getSupportedCurrencies", props],
    queryFn: () => getSupportedCurrencies(props)
  }, options));
};

export {
  useGetSupportedCurrencies
};
//# sourceMappingURL=chunk-AKXOIQKD.mjs.map